import { extractAddress } from 'blockscope/utils/helperUtils';

const minimizeTraceCallStack = (callStack) => {
  const { rawCall, calls, logs, decodedCall } = callStack;
  const minimizedCallStack = {
    from: {
      address: extractAddress(rawCall.from.enriched),
      name: rawCall.from.contractName || rawCall.from.enriched?.name,
      labels: rawCall.from.enriched?.labels.map((l) => l.label) || [],
    },
    to: {
      address: extractAddress(rawCall.to.enriched),
      name: rawCall.to.contractName || rawCall.to.enriched?.name,
      labels: rawCall.to.enriched?.labels.map((l) => l.label) || [],
    },
    value: rawCall.value?.displayText,
  };

  if (decodedCall) {
    minimizedCallStack.decoded = decodedCall;
  } else {
    minimizedCallStack.input = 'undecoded input';
    minimizedCallStack.output = 'undecoded output';
  }
  if (logs?.length > 0) {
    minimizedCallStack.logs = logs.map((log) => {
      const { rawLog, decodedLog, contractName } = log;
      const minimizedLog = {
        address: {
          address: extractAddress(rawLog.address),
          name: contractName || rawLog.address.name,
          labels: rawLog.address.labels.map((l) => l.label) || [],
        },
        decoded: decodedLog || 'Undecoded Log',
      };
      return minimizedLog;
    });
  }
  if (calls?.length > 0) {
    minimizedCallStack.calls = calls.map((call) =>
      minimizeTraceCallStack(call)
    );
  }

  return minimizedCallStack;
};
/**
 * Process Transaction Decode Report JSON data
 * @param {Array} txnData - Array of JSON file objects
 * @param {string} input - User input text
 * @param {Array} uploadedImages - Uploaded images
 * @returns {Object} - Object containing processed JSON files and messages
 */
export const processDecoderTraceCall = (txnData, input, uploadedImages) => {
  const callStack = minimizeTraceCallStack(txnData[0].data.decodedCallStack);

  // Create first system message with original JSON data
  const systemDataMessage = {
    role: 'user',
    content: `
      Instructions:

      Analyze this Blockscope Transaction Decode Report and provide a response to the user.

      Detailed label data:
      ${JSON.stringify(callStack, null, 2)}
      `,
  };

  // Create user message
  const userMessage = {
    role: 'user',
    content: [
      {
        type: 'text',
        text: input, // inputmessage is fetched from actionplan default
      },
      ...(uploadedImages
        ? uploadedImages.map((m) => ({ type: 'image', image: m[0] }))
        : []),
    ],
  };

  return {
    messages: {
      dataMessages: [systemDataMessage],
      userMessage,
    },
  };
};
